import store from '@/store'

export default [
  {
    path: '/study-times',
    name: 'study-time',
    meta: { requiresAuth: true },
    component: () => import('@/pages/study-time/form.vue'),
    beforeEnter: async (to, from, next) => {
      // await store.dispatch('subProgram/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/study-times/:id',
    name: 'study-time-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/study-time/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('studyTime/find', to.params.id)
      next()
    }
  }
]
